import * as React from 'react'
import { Currency } from './Currency'
import { Tooltip } from 'antd-v4'
import { PermissionNames } from '@getgreenline/homi-shared'
import { Icon } from 'antd'

interface Props {
  canViewCustomerTotalSpend: boolean
  totalSpend: number
  usePoints?: boolean
}

export const CustomerTotalSpend = (props: Props) => {
  return props.canViewCustomerTotalSpend ? (
    props.usePoints ? (
      <div>{props.totalSpend}</div>
    ) : (
      <Currency centValue={props.totalSpend} />
    )
  ) : (
    <Tooltip
      placement='left'
      title={
        <div>
          <div>Your account does not have the </div>
          <div>"{PermissionNames.CAN_VIEW_CUSTOMER_TOTAL_SPEND}" permission.</div>
          <br />
          <span>Please ask your administrator for access.</span>
        </div>
      }
    >
      <Icon type='lock' />
    </Tooltip>
  )
}
